// React
import React from 'react';
// External
import { Container, Form, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { BiSearch } from 'react-icons/bi';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import FooterBtnActions from 'components/shared/molecules/FooterBtnActions/FooterBtnActions';
import Stepper from 'components/shared/atoms/Stepper/Stepper';
import AlertDismissible from 'components/shared/atoms/AlertDismissible/AlertDismissible';
import SpecialInstructions from 'components/new-booking/SpecialInstructions/SpecialInstructions';
import BookingDetails from 'components/new-booking/BookingDetails/BookingDetails';
import ProductList from 'components/new-booking/ProductList/ProductList';
import PageTitleWithCart from 'components/shared/molecules/PageTitleWithCart/PageTitleWithCart';
import BookingSubmitted from 'components/new-booking/BookingSubmitted/BookingSubmitted';
import SelectBundle from 'components/new-booking/SelectBundle/SelectBundle';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import {
    createBooking, addSpecialInstruction, completeBooking, editBooking, getBooking
} from 'services/booking';
import {
    updateBooking,
    clearBooking
} from 'stores/actions';
// Constants
import PRIVATE_PACKAGE_STEPS from 'constants/privatePackageSteps';
// Styles
import './styles.scss';
// Models
import Owner from 'models/Owner';
import Pet from 'models/Pet';
import Booking from 'models/Booking';
import OwnerPetDetailsForm from 'components/new-booking/OwnerPetDetailsForm/OwnerPetDetailsForm';
import VetService from 'services/vet';
import PRODUCT_LIST_FILTERS from 'constants/productListFilters';
import Selector from 'components/shared/atoms/Selector/Selector';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { isEmptyObject } from 'jquery';
import config from 'config/config';
import Pusher from 'pusher-js';
import { logErrorToAtatus } from 'services/atatus';

const DEFAULT_ERROR_MSG = "Something went wrong. Please verify the information and try again.";
const DISPERSAL_SERVICE_TYPE_NAME = 'private cremation & dispersal of ashes';

class Package extends React.Component {
    constructor(props) {
        super(props);
        const filterFromStorage = localStorage.getItem('product-filter') ?? '';
        const searchFromStorage = localStorage.getItem('product-search') ?? '';
        // check url
        const isEdit = this.props.match.path === '/edit-booking-package/:id' ? true : false;

        this.filters = this.getCategoryFilters();

        this.isAshesDispersalServiceType = false;
        this.ashesDespersalServiceTypeName = '';

        this.checkIfAshesDispersalServiceType();

        this.state = {
            skip: false,
            headerTitle: '',
            owner: Owner,
            pet: Pet,
            steps: this.getStepsArray(),
            searchValue: searchFromStorage,
            isLoading: false,
            alertFail: {
                show: false,
                message: DEFAULT_ERROR_MSG,
            },
            displayBundleCustomisation: false,
            filter: filterFromStorage !== '' ? filterFromStorage : this.filters[0].value,
            vetDetails: null,
            hasSelectedProduct: false,
            packageSubmitted: false,
            bundleLists: [],
            isEdit: isEdit,
            isBookingLoaded: false,
            bookingImage: '',
            ownerPetDetailsDisabled: false,
            isVetDirect: false,
            isUnsubmitted: true,
            petWeightEditable: false,
        };
        this.formComponent = React.createRef();
        this.formComponentSecondary = React.createRef();
        this.ownerPetformComponent = {
            owner: React.createRef(),
            pet: React.createRef()
        };
        this.bookingDetailsRef = React.createRef();
        // if edit, get booking details
        this.getBookingDetails();
        if (!isEdit) {
            this.state.isBookingLoaded = true;
        }
    }

    /**
     * Checks if the current service type is the ashes dispersal service type.
     * Retrieves the service type name from the existing booking or local storage.
     * Updates the internal state and steps array accordingly.
     *
     * @returns {void}
     */
    checkIfAshesDispersalServiceType() {
        // Get the service type name from either the existing booking or local storage
        const serviceTypeFromBooking = !isNil(this.props?.booking?.getServiceTypeName()) ? this.props.booking.getServiceTypeName().toLowerCase() : undefined;
        const serviceTypeFromLocalStorage = !isNil(localStorage?.getItem('service-type-name')) ? localStorage.getItem('service-type-name').toLowerCase() : undefined;

        let isAshesDispersal = false;

        // Check if the service type name is the ashes dispersal service type
        if (!isNil(serviceTypeFromLocalStorage) && !isEmpty(serviceTypeFromLocalStorage)) {
            isAshesDispersal = serviceTypeFromLocalStorage === DISPERSAL_SERVICE_TYPE_NAME;
            this.ashesDespersalServiceTypeName = serviceTypeFromLocalStorage;
        } else if (!isNil(serviceTypeFromBooking) && !isEmpty(serviceTypeFromBooking)) {
            isAshesDispersal = serviceTypeFromBooking === DISPERSAL_SERVICE_TYPE_NAME;
            this.ashesDespersalServiceTypeName = serviceTypeFromBooking;

            // Set the service type name in local storage using the booking data
            localStorage.setItem('service-type-name', serviceTypeFromBooking);
        }

        if (this.isAshesDispersalServiceType !== isAshesDispersal) {
            this.isAshesDispersalServiceType = isAshesDispersal;

            const newSteps = [...this.getStepsArray()];

            this.setState(prevState => ({ ...prevState, steps: newSteps }));
        }
    }

    componentDidMount() {
        this.updateStepData();
        if (!this.state.isEdit) {
            this.getVetDetails();
        } else {
            localStorage.removeItem('is-pet-next');
        }
    }

    componentDidUpdate(prevProps) {
        this.updateStepData();
        // set owner and pet details if booking is updated
        if ((prevProps.booking !== this.props.booking) && this.state.isEdit && !this.state.isBookingLoaded) {
            this.subscribeToPusher();

            // get booking image
            this.props.booking.getImage().then((response) => {
                if (!isEmptyObject(response.data)) {
                    this.setState(prevState => ({ ...prevState, bookingImage: response.data}));
                }
            });
            // get vet relationship type
            VetService.getVetDetails().then((response) => {
                let isVetDirect = false;
                if (response.data.cstm.relationship_type_c === "vet_direct") {
                    isVetDirect = true;
                }
                this.setState(prevState => ({ ...prevState, isVetDirect }), () => {
                    this.props.booking.owner.phoneNumber = this.props.booking.owner.phoneNumber.replace("+61", "0");
                    if (this.props.booking.skipOwnerDetails === null) {
                        this.props.booking.skipOwnerDetails = response.data.cstm.provides_client_details_c == 0 ? 1 : 0;
                    }
                    this.setState(prevState => ({ ...prevState, petWeightEditable: this.props.booking.pet.weight === "" ? true : false, owner: this.props.booking.owner, pet: this.props.booking.pet, isBookingLoaded: true, skip: this.props.booking.skipOwnerDetails == 1 ? true : false, vetDetails: response.data, isUnsubmitted: this.props.booking.parsedOrderStage?.includes('Unsubmitted')}), () => {
                        if (this.props.booking.parsedOrderStage.includes("Submitted") || this.props.booking.parsedOrderStage.includes("In Progress")) {
                            this.setState(prevState => ({ ...prevState, ownerPetDetailsDisabled: true }));
                        }
                    });
                });
            });

            this.checkIfAshesDispersalServiceType();
        }
    }

    componentWillUnmount() {
        if (this.channel) {
            // Unsubscribe from Pusher channel
            this.channel.unsubscribe();
        }
    }

    /**
     * [getBookingDetails get booking details]
     *
     */
    getBookingDetails() {
        getBooking(this.props.match.params.id)
            .then((response) => {
                const booking = Booking(response.data);
                this.props.updateBooking({...booking});
            }).catch((err) => {
                console.error('err :>> ', err);
            });
    }

    /**
     * Gets the category filters
     *
     * @returns {array}
     */
     getCategoryFilters() {
        const excludedFilters = [];

        let filteredFilters = PRODUCT_LIST_FILTERS.filter(filter => !excludedFilters.includes(filter.name));

        // Remove the first (all) filter if there is only 2 filters left
        if (filteredFilters.length <= 2) {
            filteredFilters.shift();
        }

        return filteredFilters;
    }

    /**
     * Retrieves the vet details
     */
    getVetDetails = () => {
        VetService.getVetDetails()
            .then((response) => {
                // set skip
                this.setState(prevState => ({ ...prevState, skip: response.data.cstm.provides_client_details_c == 0 ? true : false, vetDetails: response.data }))
                this.ownerPetformComponent.owner.current.handleCheckbox(this.state.skip);
            }).catch((err) => {
                console.error(err);
            });
    }

    getBookingOptionName() {
        return this.props.booking.id ? this?.props?.booking?.serviceType?.name : this?.props?.booking?.bookingOptionSelected.label
    }

    /**
     * Submit the form based on the async form component submit
     * @todo Add submit information request
     */
    async onSubmit() {
        try {
            this.setState(prevState => ({ ...prevState, isLoading: true }));
            // Gets the data about the current form step
            const currentStepIndex = this.getCurrentStepIndex();
            const currentStepName = this.state.steps[currentStepIndex].name;

            if (this.state.isSubmitted) {
                this.props.history.push(`/booking/${this.state.bookingId}`);
            } else if (currentStepName === PRIVATE_PACKAGE_STEPS.ownerPetDetails.name) {
                // handles the submission of the form of the current step
                // based on the private cremation steps
                // Saves the owner information enter on the form to continue with the pet information
                let ownerData;

                // Only save the owner details if the skip checkbox is not ticked
                if (!this.state.skip) {
                    ownerData = await this.saveOwnerDetails();
                }

                // Saves the pet information
                const petData = await this.savePetDetails();

                // Go to next step after saving the owner and pet information
                if ((ownerData || this.state.skip) && petData) {
                    await this.props.updateBooking({ skipOwnerDetails: this.state.skip, isPackage: true });

                    // The booking is created once the owner details and pet details are filled
                    try {
                        await this.submitBooking();
                        this.setState(prevState => ({ ...prevState, isLoading: false }));
                        localStorage.setItem('is-pet-next', true);
                        // Go to next step after saving the booking information
                        this.navigateNext();
                    } catch (error) {
                        logErrorToAtatus(`Failed to submit booking at ${this.getBookingOptionName()}`, {
                            ...error, 
                            message: error.message, 
                            booking_id: this.props.booking.id, 
                            booking_number: this.props.booking.orderId
                        })

                        await this.setState(prevState => ({ ...prevState,
                            alertFail: {
                                ...this.state.alertFail,
                                show: true,
                            },
                            isLoading: false
                        }));
                    } finally {
                        this.setState(prevState => ({ ...prevState, isLoading: false }));
                    }
                } else {
                    await this.setState(prevState => ({ ...prevState, isLoading: false }));
                }
            } else if (currentStepName === PRIVATE_PACKAGE_STEPS.confirmation.name) {
                if (this.props.booking.id) {
                    try {
                        // Get the screenshot image of the booking details
                        const screenshot = await this.bookingDetailsRef.current.getImage();
                        if (this.state.isUnsubmitted) {
                            await completeBooking(this.props.booking.id, {
                                screenshotImage: screenshot,
                            });
                            // remove temporary booking flag when booking is complete
                            await localStorage.removeItem('createBookingFlag')
                        }
                        localStorage.setItem('is-pet-next', true);
                        this.setState(prevState => ({ ...prevState, isSubmitted: true, bookingId: this.props.booking.id }));
                        this.props.clearBooking();
                    } catch (error) {
                        logErrorToAtatus(`Failed to submit booking at ${this.getBookingOptionName()}`, {
                            ...error, 
                            message: error.message, 
                            booking_id: this.props.booking.id, 
                            booking_number: this.props.booking.orderId
                        })

                        await this.setState(prevState => ({ ...prevState,
                            alertFail: {
                                show: true,
                                message: "Error: " + (!isNil(error?.response?.data?.errors?.detail) ? error.response.data.errors.detail : DEFAULT_ERROR_MSG),
                            },
                            isLoading: false
                        }));
                    } finally {
                        await this.setState(prevState => ({ ...prevState, isLoading: false }));
                    }
                } else {
                    await this.setState(prevState => ({ ...prevState, isLoading: false }));
                }
            } else if (currentStepName === PRIVATE_PACKAGE_STEPS.bundle.name) {
                this.setState(prevState => ({ ...prevState, packageSubmitted: true, isLoading: false }));

                // Show the confirmation dialog if there's a selected product on a non-ashes dispersal booking
                if (this.state.hasSelectedProduct) {
                    if (this.isAshesDispersalServiceType) {
                        this.navigateNext();
                        localStorage.setItem('is-pet-next', true);
                    } else {
                        confirmAlert({
                            customUI: ({ onClose }) => {
                                return (
                                <div className='alert-body'>
                                    <div className='modal-header'>
                                        <div className='modal-title h4'>Cremation package additions</div>
                                        <button type='button' className='close' onClick={onClose}>
                                            <span aria-hidden='true'>×</span>
                                        </button>
                                    </div>
                                    <div className='modal-body'>
                                        <span>Now the cremation package has been selected, there is an option of adding further keepsakes, urns and memorabilia. </span>
                                        <span>If nothing else is required, the booking can be submitted.</span>
                                    </div>
                                    <div className='modal-footer'>
                                        <button type="button" className="btn action-btn"
                                        onClick={() => {
                                            this.navigateTo(PRIVATE_PACKAGE_STEPS.productList.hash);
                                            localStorage.setItem('is-pet-next', true);
                                            onClose();
                                        }}>
                                            <b>Add Item</b>
                                        </button>
                                        <button type="button" className="btn action-btn"
                                        onClick={() => {
                                            this.navigateTo(PRIVATE_PACKAGE_STEPS.confirmation.hash);
                                            localStorage.setItem('is-pet-next', true);
                                            onClose();
                                        }}>
                                            <b>Submit Booking</b>
                                        </button>
                                    </div>
                                </div>
                                );
                            }
                        });
                    }
                }
            } else {
                // Products can click on next without verification as the booking is updated when the product is added
                // in the ProductModal
                this.navigateNext();
                await this.setState(prevState => ({ ...prevState, isLoading: false }));
                localStorage.setItem('is-pet-next', true);
            }
        } catch (error) {
            logErrorToAtatus(`Failed to submit booking at ${this.getBookingOptionName()}`, {
                ...error, 
                message: error.message, 
                booking_id: this.props.booking.id, 
                booking_number: this.props.booking.orderId
            })
            
            this.setState(prevState => ({ ...prevState, isLoading: false }));
        }
    }

    /**
     * Get an array of steps for a private package based on the service type.
     *
     * @returns {Array} An array of steps for a private package.
     */
    getStepsArray = () => {
        return Object.keys(PRIVATE_PACKAGE_STEPS)
            .map(
                (key) => PRIVATE_PACKAGE_STEPS[key]
            ).filter(
                // Remove the product step when using the Ashes Dispersal service type
                steps => (this.isAshesDispersalServiceType ? steps.name !== "productList" : true )
            );
    }

    /**
     * @returns the current index step
     */
    getCurrentStepIndex() {
        const currentStepHash = this.props.location.hash;
        for (const [index, step] of this.state.steps.entries()) {
            if (step.hash === currentStepHash) {
                return index;
            }
        }
        return null;
    }

    // Validates and stores the owner data from the form
    async saveOwnerDetails() {
        let owner = await this.ownerPetformComponent.owner.current.handleSubmit();

        if (owner) {
            owner = Owner(owner);
            const pet = Pet({ lastName: owner.lastName });
            this.setState(prevState => ({ ...prevState, owner, pet }));
            this.props.updateBooking({ owner, pet });
            return owner;
        }
        return null;
    }

    // Validates and stores the pet data from the form
    async savePetDetails() {
        let pet = await this.ownerPetformComponent.pet.current.handleSubmit();
        if (pet) {
            pet = Pet(pet);
            this.setState(prevState => ({ ...prevState, pet }));
            this.props.updateBooking({ pet });
            return pet;
        }
        return null;
    }

    /**
     * Submits the booking with the owner and the pet information
     */
    async submitBooking() {
        if (this.state.pet && this.state.owner) {
            let booking = Booking({
                ...this.props.booking,
                pet: this.state.pet,
                owner: this.state.owner,
                vet_details: this.state.vetDetails,
                has_default_product: false,
            });

            // Submits the booking request
            const response = this.props.booking.id ? await editBooking(this.props.booking.id, booking.submitFormat()) : await createBooking(booking.submitFormat());
            const bookingData = Booking(response.data);
            // After the booking being created the special instructions are submitted
            const specialInstructions = await this.submitSpecialInstructions(bookingData.id);
            // Update booking
            this.props.updateBooking({ ...bookingData, ...specialInstructions });
            localStorage.setItem('bookingName', `${this.props.booking.orderId} ${this.props.booking.pet.firstName} ${this.props.booking.pet.lastName}`);
        }
    }

    /**
     * Submits the special instructions one by one (due to the Sugar API endpoints)
     * @param {string} bookingId
     */
    async submitSpecialInstructions(bookingId) {
        let specialInstructions = await this.formComponentSecondary.current.handleSubmit();
        if (specialInstructions && bookingId) {
            specialInstructions = specialInstructions.filter((item) => item);
            const response = await addSpecialInstruction(bookingId, specialInstructions);
            const booking = Booking({ specialInstructions: response.data });
            return { specialInstructions: booking.specialInstructions };
        }
        return { specialInstructions: [] };
    }

    navigateTo(path) {
        this.props.history.push(path);
    }

    /**
     * Navigate to dashboard on cancel
     * @todo verify if you can leave the page
     */
    navigateCancel() {
        this.navigateTo('/dashboard');
    }

    /**
     * Handler to navigate to the next form after submitting the form,
     * it navigates to the next based on the current step
     */
    navigatePrev() {
        const currentStepHash = this.props.location.hash;
        let currentStepIndex = 0;
        this.state.steps.forEach((step, index) => {
            if (step.hash === currentStepHash) currentStepIndex = index;
        });
        if (this.props.location.hash === PRIVATE_PACKAGE_STEPS.bundle.hash) {
            if (this.state.displayBundleCustomisation) {
                this.setState(prevState => ({ ...prevState, displayBundleCustomisation: false }));
            } else {
                // Navigates to the previous step
                const prevStep = currentStepIndex - 1;
                this.navigateTo(this.state.steps[prevStep].hash);
            }
        } else if (currentStepIndex === 0) {
            // Navigates to new booking page if the current step is the initial
            this.navigateTo('/new-booking');
        } else if (currentStepIndex > 0) {
            // Navigates to the previous step
            const prevStep = currentStepIndex - 1;
            this.navigateTo(this.state.steps[prevStep].hash);
        }
    }

    /**
     * Handler to navigate to the next form after submitting the form,
     * it navigates to the next based on the current step
     */
    navigateNext() {
        const currentStepIndex = this.getCurrentStepIndex();
        const nextStep = currentStepIndex + 1;
        if (nextStep < this.state.steps.length) {
            // Cleans the search input value before moving to the next step
            this.setState(prevState => ({ ...prevState, searchValue: '' }));
            this.navigateTo(this.state.steps[nextStep].hash);
        }
    }

    /**
     * Subscribe to Pusher
     */
    subscribeToPusher () {
        // get user data
        const userData = JSON.parse(localStorage.getItem('userData'));
        const userId = userData.id;
        // init pusher
        const pusher = new Pusher(
            config.PUSHER.key,
            {
                cluster: config.PUSHER.cluster,
                forceTLS: true,
                authEndpoint: config.PUSHER.presence_endpoint,
                auth: {
                    params: {
                        id: userId,
                        type: 'contact',
                    }
                }
            }
        )
        // subscribe to Pusher channel
        this.channel = pusher.subscribe('presence-' + this.props.booking.id);
    }

    /**
     * Updates the data of the current step based on the constant variable of the new booking steps
     */
    updateStepData() {
        const stepHash = this.props.location.hash;

        // If the hash is not define then navigates to the first step
        if (!stepHash) this.navigateTo(PRIVATE_PACKAGE_STEPS.ownerPetDetails.hash);

        // Updates the information of the current step
        Object.keys(PRIVATE_PACKAGE_STEPS).forEach((key, index) => {
            if (PRIVATE_PACKAGE_STEPS[key].hash === stepHash) {
                const totalSteps = this.isAshesDispersalServiceType ? Object.keys(PRIVATE_PACKAGE_STEPS).length - 1 : Object.keys(PRIVATE_PACKAGE_STEPS).length;
                index = this.isAshesDispersalServiceType && index == 3 ? index - 1 : index;

                const title = `Step ${index + 1} of ${totalSteps} - ${PRIVATE_PACKAGE_STEPS[key].title}`;
                // If the current headerTitle state has change then is updated
                if (this.state.headerTitle !== title) {
                    this.setState(prevState => ({ ...prevState, headerTitle: title }));
                }
            }
        });
    }

    /**
     * Returns the form to be displayed on the current step of the new booking
     */
    headerSubcomponentView() {
        const stepHash = this.props.location.hash;
        switch (stepHash) {
            case PRIVATE_PACKAGE_STEPS.ownerPetDetails.hash:
                return (
                    <div className="skip-checkbox">
                        <h3 className='step-title header-margin'>{this.state.headerTitle}</h3>
                        <div className="form-header">Owner Details</div>
                        <Form.Check
                            type="checkbox"
                            id="skip-checkbox"
                            label="Do not provide owner details"
                        >
                            <Form.Check.Input
                                type="checkbox"
                                name="skip"
                                onChange={(event) => {
                                    this.setState(prevState => ({ ...prevState, skip: event.target.checked }));
                                    this.ownerPetformComponent.owner.current.handleCheckbox(event.target.checked);
                                }}
                                disabled={this.state.ownerPetDetailsDisabled}
                                checked={this.state.skip}
                            />
                            <Form.Check.Label>
                                Do not provide owner details
                                <span>If selected, owner details will be excluded from this booking</span>
                            </Form.Check.Label>
                        </Form.Check>
                    </div>
                );
            default:
                return null;
        }
    }

    /**
     * Returns the form to be displayed on the current step of the new booking
     */
    stepFormView() {
        const stepHash = this.props.location.hash;
        switch (stepHash) {
            case PRIVATE_PACKAGE_STEPS.ownerPetDetails.hash:
                if (!this.state.divider) this.setState(prevState => ({ ...prevState, divider: true }));
                return (
                    <div>
                        <OwnerPetDetailsForm
                            formComponent={this.ownerPetformComponent}
                            formData={{
                                owner: this.state.owner,
                                pet: this.state.pet,
                                bookingImage: this.state.bookingImage
                            }}
                            hideForm={this.state.skip}
                            ownerPetDetailsDisabled={this.state.ownerPetDetailsDisabled}
                            isEdit={this.state.isEdit}
                            petWeightEditable={this.state.petWeightEditable}
                        />
                        <hr />
                        <SpecialInstructions
                            ref={this.formComponentSecondary}
                            specialInstructions={this.props.booking.specialInstructions}
                            ownerPetDetailsDisabled={this.state.ownerPetDetailsDisabled}
                        />
                    </div>
                );
            case PRIVATE_PACKAGE_STEPS.bundle.hash:
                if (this.state.divider) {
                    this.setState(prevState => ({ ...prevState, divider: false }));
                }
                return (
                    <div>
                        <div className="productOptions">
                            <div className="product">
                            <h3 className='step-title'>{this.state.headerTitle}</h3>
                                <SelectBundle
                                ref={this.formComponent}
                                displayCustomisation={this.state.displayBundleCustomisation}
                                hasSelected={(selected) => this.setState(prevState => ({ ...prevState,hasSelectedProduct: selected }))}
                                packageSubmitted={this.state.packageSubmitted}
                                bundleList={(lists) => this.setState(prevState => ({ ...prevState,bundleLists: lists }))}
                                hasSelectedBundle={this.state.hasSelectedProduct}
                            /></div>
                            <div className="cart">
                                {
                                    <PageTitleWithCart
                                        title={`${this.state.isEdit ? 'Edit' : 'New'} private cremation`}
                                        items={this.props.booking.getQuotedProducts()}
                                        vetDetails={this.state.vetDetails}
                                        hasSelected={(selected) => this.setState(prevState => ({ ...prevState, hasSelectedProduct: selected }))}
                                        bundleLists={this.state.bundleLists}
                                        style={{ paddingTop: 55 }}
                                    />
                                }
                            </div>
                        </div>
                    </div>

                );
            case PRIVATE_PACKAGE_STEPS.productList.hash:
                // If this is an Ashes Dispersal package, redirect back to the first step
                if (this.isAshesDispersalServiceType) {
                    this.setState(prevState => ({ ...prevState, searchValue: '' }));
                    this.navigateTo(this.state.steps[0].hash);

                    return null;
                }

                if (this.state.divider) {
                    this.setState(prevState => ({ ...prevState, divider: false }));
                }

                return (
                    <Row className="productOptions">
                    <Col className="product">
                        <Row className="filter-search-subheader custom-no-caret">
                            <Form inline>
                                <Container>
                                    <Row>
                                        <Col>
                                            <h3 className='step-title'>{this.state.headerTitle}</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                id="search"
                                                placeholder="Search"
                                                value={this.state.searchValue}
                                                onChange={(event) => {
                                                    this.setState(prevState => ({ ...prevState,
                                                        searchValue: event.target.value
                                                    }), () => {
                                                        localStorage.setItem('product-search', event.target.value);
                                                        const url = new URL(window.location.href);
                                                        url.searchParams.set('page', '1');
                                                        window.history.pushState(null, '', url.toString());
                                                    });
                                                }}
                                            />
                                            <BiSearch size="18" />
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col md={2} className="filter-label-col">
                                                    <span className="filter-label">Filter</span>
                                                </Col>
                                                <Col>
                                                    <Selector
                                                        options={this.filters}
                                                        name="filters"
                                                        onChange={(value) => {
                                                            const bFilterChanged = this.state.filter !== value;

                                                            this.setState(prevState => ({ ...prevState,
                                                                filter: value
                                                            }), () => {
                                                                localStorage.setItem('product-filter', value);

                                                                // Stop if the filter has not changed its value
                                                                if (!bFilterChanged) {
                                                                    return;
                                                                }

                                                                // Get the query params from the url
                                                                const queryParams = new URLSearchParams(this.props.location.search);
                                                                const page = queryParams.get('page');

                                                                // If the page is not set to 1, re-set it to 1 and reload the page
                                                                if (page && page !== '1') {
                                                                    queryParams.set('page', 1);
                                                                    this.props.location.search = '?' + queryParams;
                                                                    this.props.history.push({
                                                                        pathname: this.props.location.pathname,
                                                                        search: this.props.location.search,
                                                                        hash: this.props.location.hash,
                                                                    });
                                                                    window.location.reload();
                                                                }
                                                            });
                                                        }}
                                                        value={this.state.filter}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Container>
                            </Form>
                        </Row>
                        <ProductList ref={this.formComponent} search={this.state.searchValue} filter={this.state.filter} filterOptions={this.filters} />
                    </Col>
                    <Col className='cart'>
                        {
                            <PageTitleWithCart
                                title={`${this.state.isEdit ? 'Edit' : 'New'} private cremation`}
                                items={this.props.booking.getQuotedProducts()}
                                vetDetails={this.state.vetDetails}
                                hasSelected={(selected) => this.setState(prevState => ({ ...prevState, hasSelectedProduct: selected }))}
                                bundleLists={this.state.bundleLists}
                                style={{ paddingTop: 75 }}
                            />
                        }
                    </Col>
                </Row>
                );
            case PRIVATE_PACKAGE_STEPS.confirmation.hash:
                if (this.state.divider) {
                    this.setState(prevState => ({ ...prevState, divider: false }));
                }
                return <BookingDetails booking={this.props.booking} vetDetails={this.state.vetDetails} ref={this.bookingDetailsRef} headerTitle={this.state.headerTitle}/>
            default:
                return null;
        }
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    {
                        this.ashesDespersalServiceTypeName == 'private cremation & dispersal of ashes'
                            ? <PageTitle title={`${this.state.isEdit ? 'Edit' : 'New'} private cremation package (no ashes return)`} />
                            : <PageTitle title={`${this.state.isEdit ? 'Edit' : 'New'} private cremation package`} />
                    }
                    {
                        this.props.location.hash && !this.state.isSubmitted
                            ? <Stepper steps={this.state.steps} />
                            : null
                    }
                    {
                        !this.state.isSubmitted
                            ? this.state.isBookingLoaded ? (
                                <ContentCard
                                    className="mt-28"
                                    divider={this.state.divider}
                                    headerTitle={this.state.headerTitle}
                                    headerStyle={{ paddingBottom: '10px' }}
                                    headerSubComponent={this.headerSubcomponentView()}
                                >
                                    <Container className={ "nb-container " + (this.props.location.hash === PRIVATE_PACKAGE_STEPS.confirmation.hash ? 'confirmation-page' : '')}>
                                        {this.stepFormView()}
                                    </Container>
                                </ContentCard>
                            ) : '' : (
                                <BookingSubmitted bookingId={this.state.bookingId} vetDetails={this.state.vetDetails} isUnsubmitted={this.state.isUnsubmitted}/>
                            )
                    }
                </div>
                {
                    !this.state.isSubmitted
                        ? (
                            <FooterBtnActions
                                isEdit={this.state.isEdit}
                                currentPage={this.props.location.hash}
                                showSpinner={this.state.isLoading}
                                nextBtnText={
                                    this.props.location.hash === PRIVATE_PACKAGE_STEPS.confirmation.hash
                                    ? this.state.isUnsubmitted ? 'Submit booking' : 'Confirm'
                                    : this.state.isUnsubmitted ? 'Next' : 'Save & Next'
                                }
                                cancelBtnOnCLick={() => this.navigateCancel()}
                                prevBtnOnCLick={() => this.navigatePrev()}
                                nextBtnOnCLick={() => this.onSubmit()}
                            />
                        ) : (
                            <FooterBtnActions
                                nextBtnText="View Booking"
                                nextBtnOnCLick={() => this.onSubmit()}
                            />
                        )
                }
                <AlertDismissible
                    show={this.state.alertFail.show}
                    show={this.state.alertFail.show}
                    type="danger"
                    text={this.state.alertFail.message}
                    onClose={() => this.setState(prevState => ({ ...prevState,
                        alertFail: {
                            show: false,
                            message: DEFAULT_ERROR_MSG,
                        }
                    }))}
                    text={this.state.alertFail.message}
                    onClose={() => this.setState(prevState => ({ ...prevState,
                        alertFail: {
                            show: false,
                            message: DEFAULT_ERROR_MSG,
                        }
                    }))}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ booking: state.booking });

const mapDispatchToProps = (dispatch) => {
    return {
        updateBooking: (bookingObj) => dispatch(updateBooking(bookingObj)),
        clearBooking: () => dispatch(clearBooking())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Package));
